import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import * as dealApis from "../utilities/apis/deal"

const HomeDeals = () => {
  const navigate = useNavigate()
  const [deals, setDeals] = useState([])

  const handleView = (slug) => {
    navigate(`/deal/${slug}`)
  }

  const getDeals = async () => {
    try {
      const response = await dealApis.getHomeDeals()
      if (!response.status) throw new Error(response.message)

      setDeals(response.deals)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getDeals()
  }, [])

  if (!deals.length) return null

  return (
    <section id="deals" className="py-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h1 className="fw-bold mb-3">Deals</h1>
        </div>

        <div className="row g-1">
          {deals.map((deal) => {
            return (
              <div key={deal.id.toString()} className="col-lg-2 col-md-6">
                <div className="card">
                  <img src={deal.thumbnail || "/upload.png"} className="card-img-top img-fluid deal-image" alt={deal.title} />
                  <div className="card-body p-2">
                    <p className="text-dark fw-bold m-0 text-truncate">{deal.title}</p>
                    <p className="card-text small text-muted m-0">{deal.products.length} products</p>
                    <p className="text-primary fw-bold mt-3 m-0">Rs. {(deal.price - deal.discount).toFixed(2)}</p>
                  </div>
                  <div className="card-footer p-0">
                    <button className="btn btn-sm btn-link w-100" onClick={() => handleView(deal.slug)}>View</button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeDeals